import { NetworkTaxonomyLineOfBusinessSimple, NetworkTaxonomyLineOfBusiness, NetworkTaxonomyFileType, ProjectUtilizationCategory } from "@app/network-taxonomies/networkTaxonomy";
import ServiceBase from "@app/shared/serviceBase";

export default class NetworkTaxonomyService extends ServiceBase {

  public async getLinesOfBusiness(): Promise<NetworkTaxonomyLineOfBusinessSimple[]> {
    const linesOfBusiness = await this.makeGet<NetworkTaxonomyLineOfBusinessSimple[]>(`networkTaxonomy/line-of-business`);

    return linesOfBusiness;
  }

  public async getClientFriendlyLinesOfBusiness(): Promise<NetworkTaxonomyLineOfBusinessSimple[]> {
    const linesOfBusiness = await this.makeGet<NetworkTaxonomyLineOfBusinessSimple[]>(`networkTaxonomy/line-of-business-client-friendly`);

    return linesOfBusiness;
  }

  public async getLineOfBusinessDetails(lineOfBusinessId: number): Promise<NetworkTaxonomyLineOfBusiness> {
    const lineOfBusiness = await this.makeGet<NetworkTaxonomyLineOfBusiness>(`networkTaxonomy/line-of-business/${lineOfBusinessId}/details`);

    return lineOfBusiness;
  }

  public async getFileTypes(): Promise<NetworkTaxonomyFileType[]> {
    const fileTypes = await this.makeGet<NetworkTaxonomyFileType[]>(`networkTaxonomy/file-types`);

    return fileTypes;
  }

  public async getProjectUtilizationCategories(): Promise<ProjectUtilizationCategory[]> {
    const projectUtilizationCategories = await this.makeGet<ProjectUtilizationCategory[]>(`networkTaxonomy/project-utilization-categories`);

    return projectUtilizationCategories;
  }
}